/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"
import type {
	MarketingRunDetail,
	MarketingRunListResponse,
	MarketingRunQueuedResponse,
	MarketingRunRecipientsResponse,
	MarketingRunsSummaryResponse,
} from ".././types/marketing"
import {
	MarketingAudienceRulesMatch,
	MarketingReportFieldKey,
	MarketingRunStatus,
	MarketingTaskStatus,
	MarketingTaskType,
	UpcomingAppointmentExclusionScope,
} from ".././types/marketing"

export const getGetMarketingRunsSummaryResponseMock = (
	overrideResponse: Partial<Extract<MarketingRunsSummaryResponse, object>> = {},
): MarketingRunsSummaryResponse => ({
	runsCount: 6,
	deliveredCount: 885,
	deliveredPercent: 95,
	exportsCount: 2,
	errorsCount: 48,
	periodLabel: "Последние 30 дней",
	...overrideResponse,
})

export const getListMarketingRunsResponseMock = (
	overrideResponse: Partial<Extract<MarketingRunListResponse, object>> = {},
): MarketingRunListResponse => ({
	data: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		runAt: faker.date.past().toISOString().slice(0, 19) + "Z",
		taskId: faker.string.alpha({ length: { min: 10, max: 20 } }),
		taskName: faker.string.alpha({ length: { min: 10, max: 20 } }),
		taskType: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		scheduleKind: faker.helpers.arrayElement(["once", "recurring"] as const),
		recipientsCount: faker.number.int(),
		providerLabel: "Мессенджеры",
		deliveredCount: faker.number.int(),
		errorsCount: faker.number.int(),
		deliveryPercent: faker.number.float({ fractionDigits: 2 }),
		fieldsCount: faker.helpers.arrayElement([faker.number.int(), null]),
		rowsCount: faker.helpers.arrayElement([faker.number.int(), null]),
	})),
	paging: {
		page: faker.number.int(),
		pageSize: faker.number.int(),
		total: faker.number.int(),
	},
	...overrideResponse,
})

export const getGetMarketingRunResponseMock = (): MarketingRunDetail => ({
	...{
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		runAt: faker.date.past().toISOString().slice(0, 19) + "Z",
		taskId: faker.string.alpha({ length: { min: 10, max: 20 } }),
		taskName: faker.string.alpha({ length: { min: 10, max: 20 } }),
		taskType: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		scheduleKind: faker.helpers.arrayElement(["once", "recurring"] as const),
		recipientsCount: faker.number.int(),
		providerLabel: "Мессенджеры",
		deliveredCount: faker.number.int(),
		errorsCount: faker.number.int(),
		deliveryPercent: faker.number.float({ fractionDigits: 2 }),
		fieldsCount: faker.helpers.arrayElement([faker.number.int(), null]),
		rowsCount: faker.helpers.arrayElement([faker.number.int(), null]),
	},
	...{
		taskSnapshot: faker.helpers.arrayElement([
			{
				...{
					type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
					name: faker.string.alpha({ length: { min: 10, max: 20 } }),
					description: faker.helpers.arrayElement([
						faker.string.alpha({ length: { min: 10, max: 20 } }),
						undefined,
					]),
					active: faker.datatype.boolean(),
					status: faker.helpers.arrayElement(
						Object.values(MarketingTaskStatus),
					),
					schedule: {
						mode: faker.helpers.arrayElement(["once", "recurring"] as const),
						once: faker.helpers.arrayElement([
							{
								at: faker.helpers.arrayElement([
									faker.date.past().toISOString().slice(0, 19) + "Z",
									undefined,
								]),
							},
							undefined,
						]),
						recurring: faker.helpers.arrayElement([
							{
								frequency: faker.helpers.arrayElement([
									faker.helpers.arrayElement(["day", "week", "month"] as const),
									undefined,
								]),
								time: "10:00",
								weekday: faker.helpers.arrayElement([
									faker.number.int({ min: 0, max: 6 }),
									undefined,
								]),
								monthDay: faker.helpers.arrayElement([
									faker.number.int({ min: 1, max: 31 }),
									undefined,
								]),
							},
							undefined,
						]),
						validity: {
							kind: faker.helpers.arrayElement([
								"forever",
								"from",
								"interval",
							] as const),
							from: faker.helpers.arrayElement([
								faker.date.past().toISOString().slice(0, 19) + "Z",
								undefined,
							]),
							to: faker.helpers.arrayElement([
								faker.date.past().toISOString().slice(0, 19) + "Z",
								undefined,
							]),
						},
						timezone: "Europe/Moscow",
					},
					audience: {
						rules: Array.from(
							{ length: faker.number.int({ min: 1, max: 5 }) },
							(_, i) => i + 1,
						).map(() => ({
							name: "client_birthday",
							operator: "birthday_eq",
							value: faker.helpers.arrayElement([
								faker.string.alpha({ length: { min: 10, max: 20 } }),
								faker.number.float({ fractionDigits: 2 }),
								faker.datatype.boolean(),
								Array.from(
									{ length: faker.number.int({ min: 1, max: 5 }) },
									(_, i) => i + 1,
								).map(() => ({})),
							]),
						})),
						rulesMatch: faker.helpers.arrayElement([
							faker.helpers.arrayElement(
								Object.values(MarketingAudienceRulesMatch),
							),
							undefined,
						]),
						savedSegmentId: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							undefined,
						]),
					},
					exclusion: faker.helpers.arrayElement([
						{
							enabled: faker.helpers.arrayElement([
								faker.datatype.boolean(),
								undefined,
							]),
							noRepeat: faker.helpers.arrayElement([
								faker.datatype.boolean(),
								undefined,
							]),
							windowDays: faker.helpers.arrayElement([
								faker.number.int({ min: 1, max: 365 }),
								undefined,
							]),
							skipUpcomingAppointment: faker.helpers.arrayElement([
								faker.datatype.boolean(),
								undefined,
							]),
							upcomingAppointmentScope: faker.helpers.arrayElement([
								faker.helpers.arrayElement(
									Object.values(UpcomingAppointmentExclusionScope),
								),
								undefined,
							]),
							upcomingSpecializationIds: faker.helpers.arrayElement([
								Array.from(
									{ length: faker.number.int({ min: 1, max: 5 }) },
									(_, i) => i + 1,
								).map(() =>
									faker.string.alpha({ length: { min: 10, max: 20 } }),
								),
								undefined,
							]),
							upcomingResourceIds: faker.helpers.arrayElement([
								Array.from(
									{ length: faker.number.int({ min: 1, max: 5 }) },
									(_, i) => i + 1,
								).map(() =>
									faker.string.alpha({ length: { min: 10, max: 20 } }),
								),
								undefined,
							]),
							rules: faker.helpers.arrayElement([
								Array.from(
									{ length: faker.number.int({ min: 1, max: 5 }) },
									(_, i) => i + 1,
								).map(() => ({
									name: "client_birthday",
									operator: "birthday_eq",
									value: faker.helpers.arrayElement([
										faker.string.alpha({ length: { min: 10, max: 20 } }),
										faker.number.float({ fractionDigits: 2 }),
										faker.datatype.boolean(),
										Array.from(
											{ length: faker.number.int({ min: 1, max: 5 }) },
											(_, i) => i + 1,
										).map(() => ({})),
									]),
								})),
								undefined,
							]),
						},
						undefined,
					]),
					message: faker.helpers.arrayElement([
						{
							text: faker.string.alpha({ length: { min: 10, max: 20 } }),
							channels: faker.helpers.arrayElement([
								Array.from(
									{ length: faker.number.int({ min: 1, max: 5 }) },
									(_, i) => i + 1,
								).map(() => ({
									type: faker.helpers.arrayElement([
										"whatsapp",
										"telegram",
										"max",
										"sms",
										"viber",
										"messengers",
									] as const),
									order: faker.number.int({ min: 1 }),
									enabled: faker.datatype.boolean(),
								})),
								undefined,
							]),
							priority: faker.helpers.arrayElement([
								faker.helpers.arrayElement(["low", "medium", "high"] as const),
								undefined,
							]),
							senderBusinessId: faker.helpers.arrayElement([
								faker.string.alpha({ length: { min: 10, max: 20 } }),
								undefined,
							]),
							smsIntegrationId: faker.helpers.arrayElement([
								faker.string.alpha({ length: { min: 10, max: 20 } }),
								undefined,
							]),
							smsChannel: faker.helpers.arrayElement([
								faker.string.alpha({ length: { min: 10, max: 20 } }),
								undefined,
							]),
							mediaId: faker.helpers.arrayElement([
								faker.string.alpha({ length: { min: 10, max: 20 } }),
								null,
							]),
							mediaUrl: faker.helpers.arrayElement([
								faker.internet.url(),
								null,
							]),
						},
						undefined,
					]),
					report: faker.helpers.arrayElement([
						{
							fields: Array.from(
								{ length: faker.number.int({ min: 1, max: 5 }) },
								(_, i) => i + 1,
							).map(() => ({
								key: faker.helpers.arrayElement(
									Object.values(MarketingReportFieldKey),
								),
								order: faker.number.int({ min: 1 }),
							})),
							email: faker.helpers.arrayElement([
								{
									enabled: faker.datatype.boolean(),
									recipient: faker.helpers.arrayElement([
										faker.internet.email(),
										undefined,
									]),
									archivePassword: faker.helpers.arrayElement([
										faker.string.alpha({ length: { min: 10, max: 20 } }),
										undefined,
									]),
								},
								undefined,
							]),
						},
						undefined,
					]),
				},
				...{
					id: faker.string.alpha({ length: { min: 10, max: 20 } }),
					status: faker.helpers.arrayElement(
						Object.values(MarketingTaskStatus),
					),
					scheduleLabel: "Каждый день в 10:00",
					nextRunAt: faker.helpers.arrayElement([
						faker.date.past().toISOString().slice(0, 19) + "Z",
						null,
					]),
					lastRunAt: faker.helpers.arrayElement([
						faker.date.past().toISOString().slice(0, 19) + "Z",
						null,
					]),
					lastRunStatus: faker.helpers.arrayElement([
						faker.helpers.arrayElement(Object.values(MarketingRunStatus)),
						null,
					]),
					createdAt: faker.date.past().toISOString().slice(0, 19) + "Z",
					updatedAt: faker.date.past().toISOString().slice(0, 19) + "Z",
				},
			},
			undefined,
		]),
		reportUrl: faker.helpers.arrayElement([faker.internet.url(), null]),
		reportExpiresAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
	},
})

export const getListMarketingRunRecipientsResponseMock = (
	overrideResponse: Partial<
		Extract<MarketingRunRecipientsResponse, object>
	> = {},
): MarketingRunRecipientsResponse => ({
	data: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		recipientId: faker.string.alpha({ length: { min: 10, max: 20 } }),
		clientId: faker.string.alpha({ length: { min: 10, max: 20 } }),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		phone: faker.string.alpha({ length: { min: 10, max: 20 } }),
		finalChannel: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			null,
		]),
		status: faker.helpers.arrayElement([
			faker.helpers.arrayElement([
				"delivered",
				"failed",
				"pending",
				"skipped",
			] as const),
			undefined,
		]),
		error: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			null,
		]),
		attempts: faker.helpers.arrayElement([
			Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({
				channel: faker.string.alpha({ length: { min: 10, max: 20 } }),
				status: faker.helpers.arrayElement([
					"delivered",
					"failed",
					"pending",
					"skipped",
				] as const),
				attemptedAt: faker.date.past().toISOString().slice(0, 19) + "Z",
				error: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					null,
				]),
			})),
			undefined,
		]),
	})),
	paging: {
		page: faker.number.int(),
		pageSize: faker.number.int(),
		total: faker.number.int(),
	},
	...overrideResponse,
})

export const getResendMarketingRunResponseMock = (
	overrideResponse: Partial<Extract<MarketingRunQueuedResponse, object>> = {},
): MarketingRunQueuedResponse => ({
	runId: faker.string.alpha({ length: { min: 10, max: 20 } }),
	status: faker.helpers.arrayElement(["queued", "running"] as const),
	...overrideResponse,
})

export const getResendMarketingRunRecipientResponseMock = (
	overrideResponse: Partial<Extract<MarketingRunQueuedResponse, object>> = {},
): MarketingRunQueuedResponse => ({
	runId: faker.string.alpha({ length: { min: 10, max: 20 } }),
	status: faker.helpers.arrayElement(["queued", "running"] as const),
	...overrideResponse,
})

export const getDownloadMarketingRunReportResponseMock = (): ArrayBuffer =>
	faker.helpers.arrayElement([
		new ArrayBuffer(faker.number.int({ min: 1, max: 64 })),
		new ArrayBuffer(faker.number.int({ min: 1, max: 64 })),
	])

export const getGetMarketingRunsSummaryMockHandler = (
	overrideResponse?:
		| MarketingRunsSummaryResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) =>
				| Promise<MarketingRunsSummaryResponse>
				| MarketingRunsSummaryResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/runs/summary",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingRunsSummaryResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getListMarketingRunsMockHandler = (
	overrideResponse?:
		| MarketingRunListResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingRunListResponse> | MarketingRunListResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/runs",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getListMarketingRunsResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetMarketingRunMockHandler = (
	overrideResponse?:
		| MarketingRunDetail
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingRunDetail> | MarketingRunDetail),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/runs/:runId",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingRunResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getListMarketingRunRecipientsMockHandler = (
	overrideResponse?:
		| MarketingRunRecipientsResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) =>
				| Promise<MarketingRunRecipientsResponse>
				| MarketingRunRecipientsResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/runs/:runId/recipients",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getListMarketingRunRecipientsResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getResendMarketingRunMockHandler = (
	overrideResponse?:
		| MarketingRunQueuedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MarketingRunQueuedResponse> | MarketingRunQueuedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/runs/:runId/resend",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getResendMarketingRunResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}

export const getResendMarketingRunRecipientMockHandler = (
	overrideResponse?:
		| MarketingRunQueuedResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MarketingRunQueuedResponse> | MarketingRunQueuedResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/runs/:runId/recipients/:recipientId/resend",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getResendMarketingRunRecipientResponseMock(),
				{ status: 202 },
			)
		},
		options,
	)
}

export const getDownloadMarketingRunReportMockHandler = (
	overrideResponse?:
		| ArrayBuffer
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<ArrayBuffer> | ArrayBuffer),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/runs/:runId/download",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			const binaryBody =
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getDownloadMarketingRunReportResponseMock()
			return HttpResponse.arrayBuffer(
				binaryBody instanceof ArrayBuffer ? binaryBody : new ArrayBuffer(0),
				{
					status: 200,
					headers: { "Content-Type": "application/octet-stream" },
				},
			)
		},
		options,
	)
}
export const getMarketingRunsMock = () => [
	getGetMarketingRunsSummaryMockHandler(),
	getListMarketingRunsMockHandler(),
	getGetMarketingRunMockHandler(),
	getListMarketingRunRecipientsMockHandler(),
	getResendMarketingRunMockHandler(),
	getResendMarketingRunRecipientMockHandler(),
	getDownloadMarketingRunReportMockHandler(),
]
